import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';

const ParentFormDialog = ({ 
  visible, 
  onHide, 
  editingParent, 
  parentForm, 
  setParentForm, 
  handleSaveParent,
  loading 
}) => {
  return (
    <Dialog header={editingParent ? 'Edit Parent' : 'Add New Parent'} visible={visible} onHide={onHide} style={{ width: '500px' }} footer={(
      <div className="flex justify-between items-center mt-4">
        <Button label="Cancel" icon="pi pi-times" onClick={onHide} disabled={loading} className="bg-black text-white rounded-lg px-4 py-2 hover:bg-gray-900 transition-all disabled:opacity-50 disabled:cursor-not-allowed" />
        <Button label={loading ? 'Loading' : (editingParent ? 'Update' : 'Create')} icon="pi pi-check" onClick={ handleSaveParent} loading={loading} className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg px-4 py-2 shadow-md hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed" />
      </div>
    )}>
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Name </label>
            <InputText value={parentForm.name} onChange={(e) => setParentForm({ ...parentForm, name: e.target.value })} placeholder="Enter name" className="w-full" required disabled={loading} />
          </div>
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Last Name *</label>
            <InputText value={parentForm.lastName} onChange={(e) => setParentForm({ ...parentForm, lastName: e.target.value })} placeholder="Enter last name" className="w-full" required disabled={loading} />
          </div> */}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
          <InputText value={parentForm.email} onChange={(e) => setParentForm({ ...parentForm, email: e.target.value })} placeholder="Enter email address" className="w-full" required disabled={loading} />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Mobile *</label>
          <InputText value={parentForm.phone} onChange={(e) => setParentForm({ ...parentForm, phone: e.target.value.replace(/\D/g, '') })} placeholder="Enter mobile number" className="w-full" required disabled={loading} />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Address *</label>
          <InputTextarea value={parentForm.address} onChange={(e) => setParentForm({ ...parentForm, address: e.target.value })} placeholder="Enter address" rows={3} className="w-full" required disabled={loading} />
        </div>
      </div>
    </Dialog>
  );
};

export default ParentFormDialog;
